import { Method } from "../../../../../types";
import { Link } from "../page";

// Undersøgelsens metode has multiple sub versions. These are handled here.
interface Props {
  method: Method | undefined | null;
}

export function UndersoegelsensMetodeMap({ method }: Props) {
  if (!method) return null;
  switch (method.methodType) {
    case "other":
      if (method.methodSubType === "laboratory") {
        return (
          <>
            <b>Laboratorieforsøg med dyr eller celler:</b> Resultater fra forsøg
            med dyr og celler kan ikke uden videre overføres til menneskets
            verden. Dyre- og laboratorieforsøg egner sig bedst til at opstille
            hypoteser, som skal testes i andre typer forsøg, før man kan tale om
            evidens.
            <br />
            <br />
            Mere i artiklen:{" "}
            <Link link="https://videnskab.dk/krop-sundhed/siger-forsog-pa-mus-overhovedet-noget-om-mennesker/">
              Siger forsøg på mus overhovedet noget om mennesker?
            </Link>
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      if (method.methodSubType === "case_study") {
        return (
          <>
            <b>Case-studie:</b> Beskrivelse af enkelte tilfælde. Casestudier kan
            bruges til at få øje på mønstre, så forskere kan opstille en
            hypotese. Mønstre, afdækket i casestudier, skal testes med andre
            metoder, før man kan tale om evidens.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      if (method.methodSubType === "survey") {
        return (
          <>
            <b>Spørgeskemaundersøgelser/evalueringer:</b> Undersøgelser, hvor
            man spørger en gruppe mennesker, om de f.eks. har fået noget ud af
            en behandling, hvordan de har det, eller hvordan de oplever noget.
            Giver som udgangspunkt lav evidens, fordi respondenternes svar ikke
            er objektive.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      return (
        <>
          <b>Andre metoder</b>
          <br />
          <br />
          Når man vurderer, om der er evidens for, at en behandling virker,
          eller at noget gør os syge eller sunde, tester man det med en
          videnskabelig metode.
          <br />
          <br />
          Grafikken viser, at forskellige metoder giver forskellige grader
          evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
          som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
        </>
      );
    case "review":
      return (
        <>
          <b>Systematisk review:</b> Videnskabelig analyse af al den forskning,
          der er lavet på et felt. Resultatet bygger på en objektiv og
          videnskabelig vurdering af den samlede forskning. Derfor vurderes det
          som meget pålideligt.
          <br />
          <br />
          Når man vurderer, om der er evidens for, at en behandling virker,
          eller at noget gør os syge eller sunde, tester man det med en
          videnskabelig metode.
          <br />
          <br />
          Grafikken viser, at forskellige metoder giver forskellige grader
          evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
          som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
        </>
      );
    // @ts-ignore todo, delete this when safe
    case "rtc":
    case "rct":
      return (
        <>
          <b>RCT:</b> Studiet er et lodtrækningsforsøg - et randomiseret
          kontrolleret forsøg (RCT). Metoden er den bedste til at teste, om et
          lægemiddel har effekt.
          <br />
          <br />
          Når man vurderer, om der er evidens for, at en behandling virker,
          eller at noget gør os syge eller sunde, tester man det med en
          videnskabelig metode.
          <br />
          <br />
          Grafikken viser, at forskellige metoder giver forskellige grader
          evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
          som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
        </>
      );
    case "population":
      if (method.methodSubType === "randomized") {
        return (
          <>
            <b>Mendelsk randomisering</b> er en type befolkningsundersøgelse,
            der er bedre end almindelige registerstudier til at fastslå, om en
            adfærd har en bestemt effekt - altså om der er en årssagssammenhæng.{" "}
            <Link link="https://videnskab.dk/krop-sundhed/mendelsk-randomisering-ny-metode-er-forskernes-vises-sten/">
              Mendelsk randomisering
            </Link>{" "}
            inddrager viden om genetik i den undersøgte gruppe mennesker og kan
            næsten give lige så stærke svar, som et lodtrækningsforsøg (RCT) kan
            give.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }

      return (
        <>
          <b>Befolkningsundersøgelser</b> finder statistiske sammenhænge
          (korrelationer), så forskere kan opstille hypoteser om, at der er
          årsagssammenhænge (kausalitet). Et enkelt registerstudie giver ikke
          stærk evidens for årsagssammenhæng.
          <br />
          <br />
          Mere i artiklen:{" "}
          <Link link="https://videnskab.dk/kultur-samfund/korrelation-eller-kausalitet-hvornaar-er-der-en-aarsagssammenhaeng/">
            Korrelation eller kausalitet? Hvornår er der en årsagssammenhæng?
          </Link>
          <br />
          <br />
          Når man vurderer, om der er evidens for, at en behandling virker,
          eller at noget gør os syge eller sunde, tester man det med en
          videnskabelig metode.
          <br />
          <br />
          Grafikken viser, at forskellige metoder giver forskellige grader
          evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
          som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
        </>
      );
    case "assessment":
      if (method.methodSubType === "anecdotes") {
        return (
          <>
            <b>Anekdoter</b> kan som udgangspunkt ikke bruges til ret meget i
            videnskabelig sammenhæng. Anekdoter skal testes med videnskabelige
            metoder, før man kan tale om evidens.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      if (method.methodSubType === "researcher_overview") {
        return (
          <>
            <b>Forskningsoversigt:</b> Samling af artikler om et emne. Adskiller
            sig fra systematiske reviews og metaanalyser, fordi der ikke er
            brugt en videnskabelig metode til at udvælge artikler, der er med.
            Forfatteren kan have cherrypicket - det vil sige, at han/ hun kun
            har medtaget studier, der passer til et budskab, han/hun gerne vil
            have frem, men har udeladt studier, der peger i en anden retning.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      if (method.methodSubType === "comment_opinion") {
        return (
          <>
            <b>Kommentar-/opinion-artikler:</b> Videnskabelige tidsskrifter
            bringer nogle gange kommentarer fra forskere. I modsætning til
            videnskabelige artikler, som beskriver den metode, forskerne har
            brugt, samt hvordan de er nået frem til deres resultat, er
            kommentarer sjældent fagfællebedømte, og de er et udtryk for
            forskerens egen opfattelse.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      if (method.methodSubType === "reports_public_orgs") {
        return (
          <>
            <b>
              Rapporter fra ministerier, tænketanke og interesseorganisationer:{" "}
            </b>
            Vær på vagt! Stærke interesser er på spil, og der er stor risiko
            for, at de smitter af på resultatet. For at kunne stole på, at et
            resultat er objektivt,{" "}
            <Link link="https://videnskab.dk/kultur-samfund/raad-2-tjek-om-forskningen-er-trykt-i-et-videnskabeligt-tidsskrift/">
              skal det bedømmes af uafhængige forskere
            </Link>
            , før det publiceres. Det sker sjældent med rapporter fra
            ministerier, tænketanke og interesseorganisationer.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      if (method.methodSubType === "reports_university_not_assessed") {
        return (
          <>
            <b>Ikke-fagfællebedømte rapporter fra universiteter: </b>
            Man skulle tro, at rapporter fra universiteter bygger på stærk
            evidens. Men hvis en rapport{" "}
            <Link link="https://videnskab.dk/kultur-samfund/raad-2-tjek-om-forskningen-er-trykt-i-et-videnskabeligt-tidsskrift/">
              ikke er fagfællebedømt af uafhængige forskere
            </Link>
            , kan man ikke vide sig sikker - heller ikke, selvom rapporten er
            udgivet af et universitet.
            <br />
            <br />
            Når man vurderer, om der er evidens for, at en behandling virker,
            eller at noget gør os syge eller sunde, tester man det med en
            videnskabelig metode.
            <br />
            <br />
            Grafikken viser, at forskellige metoder giver forskellige grader
            evidens. Jo højere, metoden befinder sig, des stærkere er evidensen
            som hovedregel. Metoden er afgørende for bedømmelsen af studiet.
          </>
        );
      }
      return null;
    default:
      break;
  }
  return null;
}
